export default "__VITE_ASSET__B8EdLI_Z__"